import { Play, ArrowUpRight } from "lucide-react";
import { Reveal, SectionHeading, EASE } from "./Reveal";
import { motion } from "framer-motion";
import { FILMS, STUDIO } from "../data/siteContent";

export default function Films() {
  return (
    <section id="films" data-testid="films-section" className="py-20 sm:py-28 lg:py-32 bg-ink-soft/30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionHeading
          eyebrow="Wedding Films"
          title={
            <>
              Lights, emotions, <span className="italic text-gold">candied slow-motion</span>
            </>
          }
          sub="Cinematic films and reels cut from real celebrations. Press play on the feeling."
        />

        <div className="grid md:grid-cols-2 gap-6 lg:gap-8">
          {FILMS.map((film, i) => (
            <Reveal key={film.title} delay={(i % 2) * 0.12}>
              <a
                data-testid={`film-card-${i + 1}`}
                href={STUDIO.instagram.url}
                target="_blank"
                rel="noreferrer"
                className="group relative block overflow-hidden aspect-video"
              >
                <motion.img
                  src={film.poster}
                  alt={`${film.title} — ${film.meta}`}
                  loading="lazy"
                  className="absolute inset-0 w-full h-full object-cover"
                  whileHover={{ scale: 1.05 }}
                  transition={{ duration: 1, ease: EASE }}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-ink/90 via-ink/20 to-ink/30" />

                <span className="absolute top-4 right-4 text-[11px] tracking-[0.2em] text-ivory/90 bg-ink/60 backdrop-blur px-3 py-1">
                  {film.duration}
                </span>

                <div className="absolute inset-0 flex items-center justify-center">
                  <span className="w-16 h-16 sm:w-20 sm:h-20 rounded-full border border-gold/70 bg-ink/40 backdrop-blur flex items-center justify-center text-gold scale-90 opacity-80 group-hover:scale-110 group-hover:opacity-100 group-hover:bg-gold group-hover:text-ink transition-all duration-500">
                    <Play className="w-6 h-6 ml-0.5" fill="currentColor" />
                  </span>
                </div>

                <div className="absolute inset-x-0 bottom-0 p-5 sm:p-6 flex items-end justify-between gap-4">
                  <div>
                    <p className="text-[10px] uppercase tracking-[0.25em] text-gold mb-1.5">
                      {film.meta}
                    </p>
                    <h3 className="font-display text-xl sm:text-2xl text-ivory">{film.title}</h3>
                  </div>
                  <span className="flex items-center gap-1.5 text-[11px] uppercase tracking-[0.18em] text-ivory-dim group-hover:text-gold transition-colors shrink-0">
                    Watch
                    <ArrowUpRight className="w-4 h-4" />
                  </span>
                </div>
              </a>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.2} className="text-center mt-10">
          <a
            data-testid="films-instagram-link"
            href={STUDIO.instagram.url}
            target="_blank"
            rel="noreferrer"
            className="inline-flex items-center gap-2 text-sm uppercase tracking-[0.2em] text-ivory-dim border-b border-gold/40 pb-2 hover:text-gold transition-colors"
          >
            More films & reels on Instagram — {STUDIO.instagram.handle}
            <ArrowUpRight className="w-4 h-4" />
          </a>
        </Reveal>
      </div>
    </section>
  );
}
